export default function dateFormat(date) {
    let newDate = new Date(date);
    let year = newDate.getFullYear();
    let month = newDate.getMonth() + 1
    let day = newDate.getDate();

    return `${year}-${month < 10 ? "0" + month : month}-${day<10? "0"+day:day}`
}
